<template>
  <div class = "paginaDedicata">
    <NormalHeader :data="header"/>
    <img :src="logo" class = "logo">
    <img :src="img1" class = "imagine">
    <h1 class = "title">{{$t(title)}}</h1> 
    <p v-html="$t(text1)" class = "text"></p>
    <img :src="img2" class = "imagine"> 
    <p v-html="$t(text2)" class = "text"></p>
    <ul>
      <li v-html="$t(bullet1)"></li>
      <li v-html="$t(bullet2)"></li>
      <li v-html="$t(bullet3)"></li>
    </ul>
    <img :src="img3" class = "imagine">
    <p v-html="$t(text3)" class = "text"></p>
  </div>  
</template>

<script>
import NormalHeader from '@/components/global-components/NormalHeader'
export default {
  components:{
    NormalHeader
  },
  data() {
    return {
      header: {
        transparent: false
      },
      logo: "https://i.imgur.com/IprzuK3.png",
      img1: "https://i.imgur.com/VFHICuZ.png",
      img2: "https://i.imgur.com/8Pvnz4R.png",
      img3: "https://i.imgur.com/aQeaNBb.jpg",
      title: "dedicate.computaris.title",
      text1: "dedicate.computaris.text1",
      text2: "dedicate.computaris.text2",
      text3: "dedicate.computaris.text3",
      bullet1: "dedicate.computaris.bullet1",
      bullet2: "dedicate.computaris.bullet2",
      bullet3: "dedicate.computaris.bullet3",
      header: {
        transparent: false
      }
    }
  }
} 
</script>

<style scoped lang="scss">
.imagine {
  margin-top: 2%!important;
  margin-bottom: 2%!important;
  padding-top: 0px;
  display: block;
  margin: auto;
  max-width: 80%;
}
.logo {
  height: 15vh;
  margin-top: 2%!important;
  margin-bottom: 3%!important;
  display: block;
  margin: auto;
}
.title {
  margin-bottom: 3%;
  font-size: 35px!important;
}
.text {
  text-align: center;
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 2%;
  margin-top: 2%;
  font-size: 20px!important;
}
.paginaDedicata {
  color: $primary-color !important;
  margin-bottom: 30px;
}
ul { 
  display: block;
  list-style-type: disc;
  color: black;
  margin-left: 10%;
  margin-right: 10%;
}
li{
  text-align: left;
  margin-bottom: 3px!important;
  font-size: 20px!important;
  margin-left: 2%;
  margin-right: 2%;
  list-style-position: inside;
}
a{
  text-align: center;
  color: black;
  font-size: 20px!important;
  display: block;
  margin-bottom: 5px;
}

@media screen and (max-width: 600px) {
  .logo {
    height: 8vh;
  }
  .title {
    margin-top: 7%!important;
  }
}

</style>